<template>
  <div id="cards" ref="con1"></div>
</template>
<script>
import pencer from "./percent";
export default {
  components: {
    pencer,
  },
  data() {
    return {
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
        sort: 2,
        startTime: "",
      },
      animate: false,
      percent: [
        {
          carNo: "粤A2545",
          count: 20,
          rank: 1,
        },
        {
          carNo: "粤A2545",
          count: 16,
          rank: 1,
        },
        {
          carNo: "粤A2545",
          count: 14,
          rank: 1,
        },
        {
          carNo: "粤A2545",
          count: 10,
          rank: 1,
        },
        {
          carNo: "粤A2545",
          count: 6,
          rank: 1,
        },
        {
          carNo: "粤A2545",
          count: 4,
          rank: 1,
        },
      ],
      big: 20,
      cars: {
        xData: ["在岗", "脱岗", "现出勤","应出勤", "请假"],
        yData: [0, 0, 0, 0,0],
      },
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      this.getData();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-ep-server-upf/screen/countAttd/person",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        var data = res.data.data;
        this.cars.yData[0] = data.onDuty;
        this.cars.yData[1] = data.notDuty;
        this.cars.yData[2] = data.actualAttd;
        this.cars.yData[3] = data.mustAttd;
        this.cars.yData[4] = data.askLeave;
        this.drawBar(this.cars);
        return;
        var data = res.data.data.dataList;
        this.persons.xData = [];
        this.persons.yData = [];
        for (let i = 0; i < data.length; i++) {
          this.persons.xData.push(data[i].customerAccount);
          this.persons.yData.push(data[i].loginNum);
        }
        this.tableData = data;
        this.drawBar(this.persons);
      });
    },
    drawBar(obj) {
      this.chart = this.echarts.init(document.getElementById("cards"), "dark");
      this.option = {
        backgroundColor: "",
        /* title: {
          text: obj.text||'',
          bottom: 10,
          left: "50%",
          textAlign: "middle",
        }, */
        grid: {
          x: 60,
          y: 10,
          x2: 10,
          y2: 60, //距离下边的距离
        },
        dataZoom: [
          {
            type: "inside",
            //type: "slider",
            start: 0, //放大起点
            //end: this.list.length<500?100:100/(this.list.length/500) //放大终点
            end: 100, //放大终点
          },
        ],
        xAxis: {
          type: "category",
          data: obj.xData,
          //axisLabel: { rotate: 60 },
        },
        yAxis: {
          type: "value",
        },
        color: "#f63",
        series: [
          {
            data: obj.yData,
            type: "bar",
          },
        ],
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return val.name + "（" + val.value + "）";
          },
        },
      };
      this.chart.setOption(this.option);
      this.chart.resize();
    },
  },
  mounted() {
    setTimeout(() => {
       this.getData();
    }, 200);
  },
};
</script>
<style>
#cards {
  width: 100%;
  height: 260px;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/control/licheng.vue